export default __webpack_public_path__ + "static/media/kquizstop.9463cf5c.png";